export function BoxThreeDSVG(props) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.150565 4.05457C0.244527 3.99297 0.363203 3.98284 0.466242 4.02764L8.13291 7.36098C8.25461 7.41389 8.33333 7.53396 8.33333 7.66667V16.6667C8.33333 16.7832 8.27246 16.8913 8.17279 16.9517C8.07313 17.0121 7.94914 17.0161 7.84581 16.9622L0.179145 12.9622C0.0690399 12.9047 0 12.7909 0 12.6667V4.33333C0 4.22098 0.0566035 4.11618 0.150565 4.05457ZM0.666667 4.84174V12.4646L7.66667 16.1168V7.88522L0.666667 4.84174Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8494 4.05457C15.7555 3.99297 15.6368 3.98284 15.5338 4.02764L7.86709 7.36098C7.74539 7.41389 7.66667 7.53396 7.66667 7.66667V16.6667C7.66667 16.7832 7.72754 16.8913 7.82721 16.9517C7.92687 17.0121 8.05086 17.0161 8.15419 16.9622L15.8209 12.9622C15.931 12.9047 16 12.7909 16 12.6667V4.33333C16 4.22098 15.9434 4.11618 15.8494 4.05457ZM15.3333 4.84174V12.4646L8.33333 16.1168V7.88522L15.3333 4.84174Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.13291 0.694307C8.04814 0.65745 7.95186 0.65745 7.86709 0.694307L0.200424 4.02764C0.078721 4.08056 0 4.20062 0 4.33333C0 4.46604 0.078721 4.58611 0.200424 4.63902L7.86709 7.97235C7.95186 8.00921 8.04814 8.00921 8.13291 7.97235L15.7996 4.63902C15.9213 4.58611 16 4.46604 16 4.33333C16 4.20062 15.9213 4.08056 15.7996 4.02764L8.13291 0.694307ZM14.8307 4.33333L8 7.30319L1.16933 4.33333L8 1.36347L14.8307 4.33333Z"
        fill="black"
      />
    </svg>
  );
}
